import { render, staticRenderFns } from "./PaymentRouting.vue?vue&type=template&id=4f81d5bc"
import script from "./PaymentRouting.vue?vue&type=script&lang=js"
export * from "./PaymentRouting.vue?vue&type=script&lang=js"
import style0 from "./PaymentRouting.vue?vue&type=style&index=0&id=4f81d5bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports